module.exports = __webpack_public_path__ + "img/Login-Background-Test.b3f51328.svg";